@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Wisconsin</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      @if (controls?.length >= 1) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[0].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[0].formControlName)?.touched &&
              reactiveForm.get(controls[0].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
            @for (control of controls[0].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[0].formControlName)?.touched) {
            @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }

      @if (controls?.length >= 2) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[1].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[1].formControlName)?.touched &&
              reactiveForm.get(controls[1].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[1].formControlName }}">
            @for (control of controls[1].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[1].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[1].formControlName)?.touched) {
            @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }
      <div class="axis-grid">
        @if (baseRules?.UMLimitEA_DropDown === "show") {
          <div class="axis-col-sm-6 axis-col-md-6">
            <div
              class="axis-form-group"
              [ngClass]="{
                'has-axis-required':
                  reactiveForm.get(controls[2].formControlName)?.value === null ||
                  reactiveForm.get(controls[2].formControlName)?.value === '',
                'has-axis-error':
                  reactiveForm.get(controls[2].formControlName)?.touched &&
                  reactiveForm.get(controls[2].formControlName)?.invalid,
              }"
            >
              <label
                class="axis-control-label"
                for="{{ controls[2].formControlName }}"
                >{{ controls[2].label }}
                <span
                  aria-hidden="true"
                  class="axis-required-indicator"
                  >*</span
                >
              </label>
              <axis-dropdown
                [dataProvider]="controls[2].data"
                id="{{ controls[2].formControlName }}"
                formControlName="{{ controls[2].formControlName }}"
                (onSelect)="onSelect(baseRules['selectionId'], controls[2].formControlName)"
              ></axis-dropdown>
              @if (reactiveForm.get(controls[2].formControlName)?.touched) {
                @if (reactiveForm.get(controls[2].formControlName)?.invalid) {
                  <span
                    class="axis-error-block"
                    role="alert"
                    >Please select the {{ controls[2].label }}.</span
                  >
                }
              }
            </div>
          </div>
        }
        @if (baseRules?.UMLIMITEPEA_DropDown === "show") {
          <div class="axis-col-sm-6 axis-col-md-6">
            <div
              class="axis-form-group"
              [ngClass]="{
                'has-axis-required':
                  reactiveForm.get(controls[3].formControlName)?.value === null ||
                  reactiveForm.get(controls[3].formControlName)?.value === '',
                'has-axis-error':
                  reactiveForm.get(controls[3].formControlName)?.touched &&
                  reactiveForm.get(controls[3].formControlName)?.invalid,
              }"
            >
              <label
                class="axis-control-label"
                for="{{ controls[3].formControlName }}"
                >{{ controls[3].label }}
                <span
                  aria-hidden="true"
                  class="axis-required-indicator"
                  >*</span
                >
              </label>
              <axis-dropdown
                [dataProvider]="controls[3].data"
                id="{{ controls[3].formControlName }}"
                formControlName="{{ controls[3].formControlName }}"
                (onSelect)="onSelect(baseRules['selectionId'], controls[3].formControlName)"
              ></axis-dropdown>
              @if (reactiveForm.get(controls[3].formControlName)?.touched) {
                @if (reactiveForm.get(controls[3].formControlName)?.invalid) {
                  <span
                    class="axis-error-block"
                    role="alert"
                    >Please select the {{ controls[3].label }}.</span
                  >
                }
              }
            </div>
          </div>
        }
        @if (baseRules?.UIMLimitEA_DropDown === "show") {
          <div class="axis-col-sm-6 axis-col-md-6">
            <div
              class="axis-form-group"
              [ngClass]="{
                'has-axis-required':
                  reactiveForm.get(controls[4].formControlName)?.value === null ||
                  reactiveForm.get(controls[4].formControlName)?.value === '',
                'has-axis-error':
                  reactiveForm.get(controls[4].formControlName)?.touched &&
                  reactiveForm.get(controls[4].formControlName)?.invalid,
              }"
            >
              <label
                class="axis-control-label"
                for="{{ controls[4].formControlName }}"
                >{{ controls[4].label }}
                <span
                  aria-hidden="true"
                  class="axis-required-indicator"
                  >*</span
                >
              </label>
              <axis-dropdown
                [dataProvider]="controls[4].data"
                id="{{ controls[4].formControlName }}"
                formControlName="{{ controls[4].formControlName }}"
              ></axis-dropdown>
              @if (reactiveForm.get(controls[4].formControlName)?.touched) {
                @if (reactiveForm.get(controls[4].formControlName)?.invalid) {
                  <span
                    class="axis-error-block"
                    role="alert"
                    >Please select the {{ controls[4].label }}.</span
                  >
                }
              }
            </div>
          </div>
        }

        @if (baseRules?.UIMLimitEPEA50TO1000_DropDown === "show") {
          <div class="axis-col-sm-6 axis-col-md-6">
            <div
              class="axis-form-group"
              [ngClass]="{
                'has-axis-required':
                  reactiveForm.get(controls[5].formControlName)?.value === null ||
                  reactiveForm.get(controls[5].formControlName)?.value === '',
                'has-axis-error':
                  reactiveForm.get(controls[5].formControlName)?.touched &&
                  reactiveForm.get(controls[5].formControlName)?.invalid,
              }"
            >
              <label
                class="axis-control-label"
                for="{{ controls[5].formControlName }}"
                >{{ controls[5].label }}
                <span
                  aria-hidden="true"
                  class="axis-required-indicator"
                  >*</span
                >
              </label>
              <axis-dropdown
                [dataProvider]="controls[5].data"
                id="{{ controls[5].formControlName }}"
                formControlName="{{ controls[5].formControlName }}"
              ></axis-dropdown>
              @if (reactiveForm.get(controls[5].formControlName)?.touched) {
                @if (reactiveForm.get(controls[5].formControlName)?.invalid) {
                  <span
                    class="axis-error-block"
                    role="alert"
                    >Please select the {{ controls[5].label }}.</span
                  >
                }
              }
            </div>
          </div>
        }
      </div>

      @if (
        baseRules?.selectionId === "StateMinimum_VaryBetweenStates" ||
        baseRules?.selectionId === "RejectWhenPossible_VaryBetweenStates"
      ) {
        <div class="axis-grid">
          @for (control of controls | slice: 2; track $index) {
            @if (baseRules[control.baseRuleKey]?.includes("show")) {
              <div class="axis-col-sm-6 axis-col-md-6">
                <div
                  class="axis-form-group"
                  [ngClass]="{
                    'has-axis-required':
                      reactiveForm.get(control.formControlName)?.value === null ||
                      reactiveForm.get(control.formControlName)?.value === '',
                    'has-axis-error':
                      reactiveForm.get(control.formControlName)?.touched &&
                      reactiveForm.get(control.formControlName)?.invalid,
                  }"
                >
                  <label
                    class="axis-control-label"
                    for="{{ control.formControlName }}"
                    >{{ control.label }}
                    <span
                      aria-hidden="true"
                      class="axis-required-indicator"
                      >*</span
                    >
                  </label>
                  <axis-dropdown
                    [dataProvider]="control.data"
                    id="{{ control.formControlName }}"
                    formControlName="{{ control.formControlName }}"
                  ></axis-dropdown>
                  @if (reactiveForm.get(control.formControlName)?.touched) {
                    @if (reactiveForm.get(control.formControlName)?.invalid) {
                      <span
                        class="axis-error-block"
                        role="alert"
                        >Please select the {{ control.label }}.</span
                      >
                    }
                  }
                </div>
              </div>
            }
          }

          @if ((baseRules?.["FixedLimitsUM_DropDown"] || "").includes("readonly")) {
            <div class="axis-col-sm-6 axis-col-lg-6">
              <div class="axis-form-group">
                <label class="axis-control-label">{{ controls[6].label }}</label>
                <div id="fixedlimitsum_50k-pdffield-wisconsin">
                  {{ controls[6].data[0].name }}
                </div>
              </div>
            </div>
          }

          @if ((baseRules?.["FixedLimitsUIM_DropDown"] || "").includes("readonly")) {
            <div class="axis-col-sm-6 axis-col-lg-6">
              <div class="axis-form-group">
                <label class="axis-control-label">{{ controls[7].label }}</label>
                <div id="fixedlimitsuim_100k-pdffield-wisconsin">
                  {{ controls[7].data[0].name }}
                </div>
              </div>
            </div>
          }

          @if ((baseRules?.["UMLimits25TO50_DropDown"] || "").includes("readonly")) {
            <div class="axis-col-sm-6 axis-col-lg-6">
              <div class="axis-form-group">
                <label class="axis-control-label">{{ controls[8].label }}</label>
                <div id="umlimits25to50_25k_50k-pdffield-wisconsin">
                  {{ controls[8].data[0].name }}
                </div>
              </div>
            </div>
          }

          @if ((baseRules?.["UIMLimits50TO100_DropDown"] || "").includes("readonly")) {
            <div class="axis-col-sm-6 axis-col-lg-6">
              <div class="axis-form-group">
                <label class="axis-control-label">{{ controls[9].label }}</label>
                <div id="uimlimits50to100_50k_100k-pdffield-wisconsin">
                  {{ controls[9].data[0].name }}
                </div>
              </div>
            </div>
          }
        </div>
      }
      @if (baseRules?.RejectUimSelectUm_LevelOne_Radio === "Yes") {
        <div class="axis-col-sm-6 axis-col-lg-4">
          <div class="axis-form-group">
            <label
              id="rejectuimselectum_levelone_radio-pdffield-wisconsin"
              class="axis-control-label"
            >
              {{ textValues?.Reject_Text }}
            </label>
          </div>
        </div>
      }
    </form>
  }
}
@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Wisconsin</h2>
  @if (baseRules?.RejectUimSelectUm_LevelOne_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label"> {{ textValues?.Reject_Text }} </label>
    </div>
  }

  <div class="axis-grid">
    @if (baseRules.FixedLimitsUM_DropDown) {
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label class="axis-control-label">{{ controls[6].label }} </label>
          <div>{{ controls[6].data[0].name }}</div>
        </div>
      </div>
    }
    @if (baseRules.FixedLimitsUIM_DropDown) {
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label class="axis-control-label"> {{ controls[7].label }} </label>
          <div>{{ controls[7].data[0].name }}</div>
        </div>
      </div>
    }
    @if (baseRules.UMLimits25TO50_DropDown) {
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label class="axis-control-label">{{ controls[8].label }} </label>
          <div>{{ controls[8].data[0].name }}</div>
        </div>
      </div>
    }
    @if (baseRules.UIMLimits50TO100_DropDown) {
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label class="axis-control-label"> {{ controls[9].label }} </label>
          <div>{{ controls[9].data[0].name }}</div>
        </div>
      </div>
    }
    @if (baseRules.UM_LiabilityLimit_DropDown) {
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label class="axis-control-label"> {{ controls[10].label }} </label>
          <div>{{ controls[10].data[0].name }}</div>
        </div>
      </div>
    }
    @if (baseRules.UIM_LiabilityLimit_DropDown) {
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label class="axis-control-label"> {{ controls[11].label }} </label>
          <div>{{ controls[11].data[0].name }}</div>
        </div>
      </div>
    }
  </div>
}
